import type { ConfigType } from '@plone/registry';

export const updateMiddlewareConfig = (config: ConfigType) => {
  if (__SERVER__) {
    const devProxyMiddleware =
      require('../express-middleware/devproxy').default;
    const resolveuidMiddleware =
      require('../express-middleware/resolveuid').default;
    const defaultPageMiddleware =
      require('../express-middleware/defaultpage').default;
    const cacheControlMiddleware =
      require('../express-middleware/cacheControl').default;
    const existing = (config.settings.expressMiddleware ?? []) as unknown[];

    // Mock do `@page-feedback` para testar o formulário da 404 sem o backend.
    // Entra antes do devproxy, senão a requisição sai para o Plone.
    const feedbackMock =
      process.env.RAZZLE_MPF_FEEDBACK_MOCK === '1'
        ? [require('../express-middleware/pageFeedbackMock').default()]
        : [];

    config.settings.expressMiddleware = [
      // Política de cache do HTML (AB#9858): primeiro da fila, porque só
      // instala o gancho em writeHead e deixa a requisição seguir.
      cacheControlMiddleware(),
      defaultPageMiddleware(),
      resolveuidMiddleware(),
      ...feedbackMock,
      devProxyMiddleware(),
      ...existing,
    ];
  }
};

export default updateMiddlewareConfig;
